import produce from 'immer'
import { assign, stubFalse } from 'lodash'

import { METADATA_TYPES } from '../../constants'
import { buildTreeHierarchy, createTreeSelectOptions } from '../../helpers'
import { COMMON_FETCH_DISH_TYPES } from '../action-types'
import { DISH_TYPES_INITIAL_STATE } from '../initial-states'

const dishTypesReducer = (state = DISH_TYPES_INITIAL_STATE, action) => {
  switch (action.type) {
    case COMMON_FETCH_DISH_TYPES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_DISH_TYPES.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: buildTreeHierarchy(
            action.payload.data.dishTypes.results,
            METADATA_TYPES.DISH_TYPES,
            '',
            '',
            [],
            1,
            action.payload.variables.disableNodes,
          ),
          options: createTreeSelectOptions(
            action.payload.data.dishTypes.results,
            'name',
            'id',
            stubFalse,
          ),
        }),
      )

    case COMMON_FETCH_DISH_TYPES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_DISH_TYPES.CLEANUP:
      return { ...DISH_TYPES_INITIAL_STATE }

    default:
      return state
  }
}

export default dishTypesReducer
